import { Button, Form, Input, Popconfirm, Table, Select, Tooltip, Typography } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import React, { useContext, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import "./Interview1003View.css";
import * as act from "../Store/actions";
import * as com from "../Common.js";
import * as st from "../State.js";

const { Paragraph } = Typography;
const mapStateToProps = (state) => {
  return {
    assetsandliabilities: state.application.assetsandliabilities,
    application: state.application,
  };
};

const mapDispatchToProps = (dispatch) => ({
  updateJointly: (event) => {
    dispatch(act.UpdateJointly(event.target.checked));
  },
  clearBorrowerBankAccounts: (index, who) => {
    dispatch(act.ClearBorrowerBankAccounts(index, who));
  },
  addBorrowerBankAccount: (i, who) => {
    dispatch(act.AddBorrowerBankAccount(i, who));
  },
  bulkAddBorrowerBankAccounts: (t, who) => {
    dispatch(act.BulkAddBorrowerBankAccounts(t, who));
  },
  bulkAddBorrowerOtherAssets: (t, who) => {
    dispatch(act.BulkAddBorrowerOtherAssets(t, who));
  },
  bulkAddBorrowerLoans: (t, who) => {
    dispatch(act.BulkAddBorrowerLoans(t, who));
  },
  bulkAddNewMortgageLoan: (t) => {
    dispatch(act.BulkAddNewMortgageLoan(t));
  },
  bulkAddBorrowerGifts: (t) => {
    dispatch(act.BulkAddBorrowerGifts(t));
  },
  bulkAddAlimonys: (t, who) => {
    dispatch(act.BulkAddAlimonys(t, who));
  },
  removeBorrowerBankAccount: (index, who) => {
    dispatch(act.RemoveBorrowerBankAccount(index, who));
  },
  changeBorrowerOwnedProperty: (t, i, v) => {
    dispatch(act.ChangeBorrowerOwnedProperty(t, i, v))
  },
  changeCoborrowerOwnedProperty: (t, i, v) => {
      dispatch(act.ChangeCoborrowerOwnedProperty(t, i, v))
  },
  changeMainProperty: (value, verb) => {
    dispatch(act.ChangeMainProperty(value, verb))
  },
});

function optionsToFormat(constant = []) {
  const MAP = {};
  const LIST = constant.map(([value, label]) => {
    MAP[value] = label;
    return { value, label };
  });
  return { MAP, LIST };
}

const ACCOUNT_TYPE = optionsToFormat(com.bankaccounttypes);
const ASSET_TYPE = optionsToFormat(com.otherassetsandcredits);
const ALIMONY_SUPPORT = optionsToFormat([
  ["alimony", "Alimony"],
  ["childsupport", "Child Support"],
  ["maintenancepayments", "Separate Maintenance"],
  ["jobrelatedexpenses", "Job Related Expenses"],
  ["other", "Other"],
]);
const CLAT = optionsToFormat([
  ["Revolving", "Revolving"],
  ["CreditLine", "Credit Line"],
  ["Installment", "Installment"],
  ["Mortgage", "Mortgage"],
  ["Open", "Open"],
  ["Other", "Other"],
])
const LIABILITIES_ACCOUNT_TYPE = optionsToFormat([
  ["Installment", "Installment"],
  ["Mortgage", "Lease"],
  ["Open", "Open 30-Day"],
  ["Revolving", "Revolving"],
  ["Unknown", "Other"],
]);
const LIEN_TYPE = optionsToFormat([
  ["firstlien", "First lien"],
  ["subordinatelien", "Subordinate lien"],
]);
const CREDIT_LOAN_TYPE = optionsToFormat([
  ["ConventionalRealEstateMortgage", "Conventional"],
  ["FHARealEstateMortgage", "FHA"],
  ["VeteransAdministrationRealEstateMortgage", "VA"],
  ["USDA-RD", "USDA-RD"],
  ["Other", "Other"],
]);
const PREPAID = optionsToFormat([
  ['yes', 'Yes'],
  ['no', 'No'],
]);
const OWNERSHIP_TYPE = optionsToFormat([
  ['Borrower', 'Borrower'],
  ['CoBorrower', 'Co-borrower'],
  ['Joint', 'Joint'],
]);
const ASSET_CREDIT_TYPE = optionsToFormat([
  ['GiftOfCash', 'Cash Gift'],
  ['GiftOfPropertyEquity', 'Gift of Equity'],
  ['Grant', 'Grant'],
]);
const DEPOSITED = optionsToFormat([
  [true, 'Deposited'],
  [false, 'Not Deposited'],
]);
const SOURCE_DESCRIPTION = optionsToFormat([
  ['CommunityNonprofit', 'Community Nonprofit'],
  ['Employer', 'Employer'],
  ['FederalAgency', 'Federal Agency'],
  ['LocalAgency', 'Local Agency'],
  ['StateAgency', 'State Agency'],
  ['Lender', 'Lender'],
  ['Relative', 'Relative'],
  ['ReligiousNonprofit', 'Religious Nonprofit'],
  ['UnmarriedPartner', 'Unmarried Partner'],
  ['Other', 'Other'],
]);
const normalizeDollarValue = (value) => {
  if (value === null || typeof value === "undefined") {
    return "";
  }
  const cleaned = value.toString().replace(/[$,\s]/g, "");
  const [integerPart = "", ...decimalParts] = cleaned.split(".");
  const integer = integerPart.replace(/\D/g, "");
  const decimal = decimalParts.join("").replace(/\D/g, "").slice(0, 2);

  if (integer === "" && decimal === "") {
    return "";
  }
  if (decimal !== "") {
    return `${integer || "0"}.${decimal}`;
  }
  return integer;
}
const getFilteredOwnershipOptions = (who) => {
  if (who === 'borrower') {
    return OWNERSHIP_TYPE.LIST.filter(
      opt => opt.value !== 'CoBorrower' && opt.label !== 'Co-borrower'
    )
  }
  if (who === 'coborrower') {
    return OWNERSHIP_TYPE.LIST.filter(
      opt => opt.value !== 'Borrower' && opt.label !== 'Borrower'
    )
  }
  return OWNERSHIP_TYPE.LIST
}
/**
 * 过滤数组
 * @param {Array} arr - 原始数组
 * @param {string} key - 用于过滤的字段名
 * @param {string} who - 'borrower' 或 'coborrower'
 * @returns {Array} 过滤后的数组
 */
const filterLiabilitiesByOwnership = (arr, key, who) => {
  if (who === 'borrower') {
    return arr.filter(item => item[key] !== 'CoBorrower')
  }
  if (who === 'coborrower') {
    return arr.filter(item => item[key] !== 'Borrower')
  }
  return arr
}

const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};
const EditableCell = ({
  title,
  type,
  options,
  children,
  dataIndex,
  record,
  handleSave,
  editMode,
  dataSource,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);
  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };
  const save = async () => {
    try {
      const values = await form.validateFields([dataIndex]);
      toggleEdit();
      handleSave({
        ...record,
        ...values,
        key: record.key
      });
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };
  let childNode = children;
  if (type === "operation") {
    return <td {...restProps}>{childNode}</td>
  }
  try {
    if (editing) {
      let ele = <Input style={{ width: '100%', height: 32 }} ref={inputRef} onPressEnter={save} onBlur={save} />;
      if (type === "inputdollar") {
        ele = (
          <Input 
            style={{ width: '100%', height: 32 }}
            ref={inputRef} 
            onPressEnter={save} 
            onBlur={save} 
            prefix="$" 
          />
        );
      } else if (type === "inputdollarmonth") {
        ele = (
          <Input
            style={{ width: '100%', height: 32 }}
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            suffix="mo"
            prefix="$"
          />
        );
      } else if (type === "select") {
        ele = (
          <Select
            style={{ width: '100%', height: 32 }}
            ref={inputRef}
            onBlur={save}
            onChange={save}
            options={options}
          />
        )
      }
      const messageTitle = typeof title === 'string' ? title : (title?.props?.children || 'This field');
      childNode = (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${messageTitle} is required.`,
            },
          ]}
        >
          {ele}
        </Form.Item>
      );
    } else {
      let text = record[dataIndex]?record[dataIndex]:""
      if (type === "inputdollarmonth" || type === "inputdollar") {
        text = "$ " + com.commaizeFloat(text)
      } else if (type === "select"){
        if (dataIndex === "deposited"){
          text = text? "Deposited": "Not Deposited"
        } else {
          const option = options.find(opt => opt.value === text);
          text = option ? option.label : text;
        }
      } else {
        text = text.toString().split(/(?=[A-Z][a-z])/).join(' ')
      }
      const isLastRow = dataSource && dataSource.length > 0 && record.key === dataSource[dataSource.length - 1].key;
      const isEmptyLastRowCell = isLastRow && (!record[dataIndex] || record[dataIndex] === "");
      childNode = (
        <div style={{width: '100%', border: '1px solid transparent'}} className={`liabilities-table-cell${isEmptyLastRowCell ? ' empty-last-row' : ''}`}>
        <Paragraph
          ellipsis={{ rows: 1, tooltip: true }}
          style={{
            minHeight: '32px',
            width: '100%',
            maxWidth: '100%',
            display: 'flex',
            alignItems: 'center',
            marginBottom: 0,
            cursor: 'pointer',
            overflow: 'hidden',
          }}
          onClick={toggleEdit}
        >
          {text}
        </Paragraph>
        </div>
      );
    }
    return <td {...restProps}>{childNode}</td>;
  } catch (error) {
    return <td {...restProps}>No data</td>;
  }

};
const LiabilitiesEditableCell = ({
  title,
  type,
  options,
  children,
  dataIndex,
  record,
  handleSave,
  editMode,
  properties,
  dataSource,
  onLinkClick,
  application,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);
  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };
  const save = async () => {
    try {
      const values = await form.validateFields([dataIndex]);
      toggleEdit();
      handleSave({
        ...record,
        ...values,
        key: record.key
      });
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };
  let childNode = children;
  if (type === "operation") {
    return <td {...restProps}>{childNode}</td>
  }
  try {
    if (editing) {
      let ele = <Input style={{ width: '100%', height: 32 }} ref={inputRef} onPressEnter={save} onBlur={save} />;
      if (type === "inputdollar") {
        ele = (
          <Input 
            style={{ width: '100%', height: 32 }}
            ref={inputRef} 
            onPressEnter={save} 
            onBlur={save} 
            prefix="$" 
          />
        );
      } else if (type === "inputdollarmonth") {
        ele = (
          <Input
            style={{ width: '100%', height: 32 }}
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            suffix="mo"
            prefix="$"
          />
        );
      } else if (type === "select") {
        ele = (
          <Select
            style={{ width: '100%', height: 32 }}
            ref={inputRef}
            onBlur={save}
            onChange={save}
            options={options}
          />
        )
      }
      const messageTitle = typeof title === 'string' ? title : (title?.props?.children || 'This field');
      childNode = (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${messageTitle} is required.`,
            },
          ]}
        >
          {ele}
        </Form.Item>
      );
    } else {
      let text = record[dataIndex]?record[dataIndex]:""
      if (type === "inputdollarmonth" || type === "inputdollar") {
        text = "$ " + com.commaizeFloat(text)
      } else if (type === "select"){
        if (dataIndex === "deposited"){
          text = text? "Deposited": "Not Deposited"
        } else {
          const option = options.find(opt => opt.value === text);
          text = option ? option.label : text;
        }
      } else {
        text = text.toString().split(/(?=[A-Z][a-z])/).join(' ')
      }
      const isLastRow = dataSource && dataSource.length > 0 && record.key === dataSource[dataSource.length - 1].key;
      const isEmptyLastRowCell = isLastRow && (!record[dataIndex] || record[dataIndex] === "");
      if (dataIndex === "creditliabilityaccounttype" && properties && text === "Mortgage") {
        const isUnlinked = record.property_id === null || record.property_id === undefined;
        childNode = (
          <div
            className={`liabilities-table-cell${isEmptyLastRowCell ? ' empty-last-row' : ''} ${isUnlinked ? 'unlinked-mortgage-cell' : ''}`}
            style={{ width: '100%', border: '1px solid transparent' }}
            onClick={toggleEdit}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <Paragraph
                ellipsis={{ rows: 1, tooltip: true }}
                style={{
                  minHeight: '32px',
                  width: 'calc(100% - 24px)',
                  maxWidth: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 0,
                  cursor: 'pointer',
                  overflow: 'hidden',
                }}
              >
                {text}
              </Paragraph>
            </div>
          </div>
        );
      } else {
        childNode = (
          <div style={{width: '100%', border: '1px solid transparent'}} className={`liabilities-table-cell${isEmptyLastRowCell ? ' empty-last-row' : ''}`}>
            <Paragraph
              ellipsis={{ rows: 1, tooltip: true }}
              style={{
                minHeight: '32px',
                width: '100%',
                maxWidth: '100%',
                display: 'flex',
                alignItems: 'center',
                marginBottom: 0,
                cursor: 'pointer',
                overflow: 'hidden',
              }}
              onClick={toggleEdit}
            >
              {text}
            </Paragraph>
          </div>
        );
      }
    }
    return <td {...restProps}>{childNode}</td>;
  } catch (error) {
    return <td {...restProps}>No data</td>;
  }

}
  
const OwnedPropertyLoansEditableCell = ({
  title,
  type,
  options,
  children,
  dataIndex,
  record,
  dataSource,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);
  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };
  const save = async () => {
    try {
      const values = await form.validateFields([dataIndex]);
      toggleEdit();
      handleSave({
        ...record,
        ...values,
        key: record.key
      });
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };
  let childNode = children;
  if (type === "operation") {
    return <td {...restProps}>{childNode}</td>
  }
  try {
    if (editing) {
      let ele = <Input style={{ width: '100%', height: 32 }} ref={inputRef} onPressEnter={save} onBlur={save} />;
      if (type === "inputdollar") {
        ele = (
          <Input 
            style={{ width: '100%', height: 32 }}
            ref={inputRef} 
            onPressEnter={save} 
            onBlur={save} 
            prefix="$" 
          />
        );
      } else if (type === "inputdollarmonth") {
        ele = (
          <Input
            style={{ width: '100%', height: 32 }}
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            suffix="mo"
            prefix="$"
          />
        );
      } else if (type === "select") {
        ele = (
          <Select
            style={{ width: '100%', height: 32 }}
            ref={inputRef}
            onBlur={save}
            onChange={save}
            options={options}
          />
        );
      }
      const messageTitle = typeof title === 'string' ? title : (title?.props?.children || 'This field');
      childNode = (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${messageTitle} is required.`,
            },
          ]}
        >
          {ele}
        </Form.Item>
      );
    } else {
      let text = record[dataIndex]?record[dataIndex]:""
      if (type === "inputdollarmonth" || type === "inputdollar") {
        text = "$ " + com.commaize(text)
      } else if (type === "select"){
        if (dataIndex === "deposited"){
          text = text? "Deposited": "Not Deposited"
        } else {
          const option = options.find(opt => opt.value === text);
          text = option ? option.label : text;
        }
      } else {
        text = text.toString().split(/(?=[A-Z][a-z])/).join(' ')
      }
      const isLastRow = dataSource && dataSource.length > 0 && record.key === dataSource[dataSource.length - 1].key;
      const isEmptyLastRowCell = isLastRow && (!record[dataIndex] || record[dataIndex] === "");
      childNode = (
        <div style={{width: '100%', border: '1px solid transparent'}} className={`liabilities-table-cell${isEmptyLastRowCell ? ' empty-last-row' : ''}`}>
          <Paragraph
            ellipsis={{ rows: 1, tooltip: true }}
            style={{
              minHeight: '32px',
              width: '100%',
              maxWidth: '100%',
              display: 'flex',
              alignItems: 'center',
              marginBottom: 0,
              cursor: 'pointer',
              overflow: 'hidden',
            }}
            onClick={toggleEdit}
          >
            {text}
          </Paragraph>
        </div>
      );
    }
    return <td {...restProps}>{childNode}</td>;
  } catch (error) {
    return <td {...restProps}>No data</td>;
  }

};
const IncomeSourcesTable = (props) => {
  const [dataSource, setDataSource] = useState(
    props.assetsandliabilities.accounts === null
      ? []
      : props.assetsandliabilities.accounts.map((a, i) => ({
          key: a.key,
          accounttype: a.accounttype,
          institution: a.bankname,
          accountnumber: a.account,
          balance: a.balance,
          ownership: a.ownership
        }))
  );
  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
    sendData(newData)
  };

  const defaultColumns = [
    {
      title: "ACCOUNT TYPE",
      dataIndex: "accounttype",
      type: "select",
      options: ACCOUNT_TYPE.LIST,
      render: (value) => ACCOUNT_TYPE?.MAP?.[value]
    },
    {
      title: "FINANCIAL INSTITUTION",
      dataIndex: "institution",
      type: "input",
    },
    {
      title: "ACCOUNT NUMBER",
      dataIndex: "accountnumber",
      type: "input",
    },
    {
      title: "CASH/MARKET VALUE",
      dataIndex: "balance",
      type: "inputdollar",
    },
    props.application.hascoborrower === "withcoborrower" && {
      title: "Ownership",
      dataIndex: "ownership",
      type: "select",
      options: getFilteredOwnershipOptions(props.currentView),
      render: (value) => OWNERSHIP_TYPE.MAP[value]
    },
    {
      title: "Delete",
      dataIndex: "operation",
      fixed: 'right',
      width: 80,
      type: "operation",
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record.key)}
          >
            <MinusCircleOutlined  style={{fontSize:16, color:"#325CEB", cursor:"pointer"}}/>
          </Popconfirm>
        ) : null,
    },
  ];
  const handleAdd = () => {
    const newData = {
      key: Math.random().toString(),
      accounttype: "CheckingAccount",
      institution: "",
      accountnumber: "",
      balance: "",
    };
    setDataSource([...dataSource, newData]);
  };
  const sendData = (newData) => {
    let tosend = newData.map((d) => {
      let balance = ''
      if (!isEmpty(d.balance)){
        const number = d.balance.toString().replace(/[^0-9.]/g, '')
        if (number !== '') {
          balance = parseInt(number).toString()
        }
      }

      return {
        key: d.key,
        bankname: d.institution,
        account: d.accountnumber,
        accounttype: d.accounttype,
        balance,
        attribution: null,
        isretirement: false,
        ownership: d.ownership
      }
    });
    props.bulkAddBorrowerBankAccounts(tosend, "borrower");
  }

  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
    sendData(newData)
  };
  const components = props.editMode ? {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  } : undefined;

  const columns = defaultColumns.filter(Boolean).map((col) => {
    return {
      ...col,
      onCell: (record) => ({
        record,
        type: col.type,
        options: col.options,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        editMode: props.editMode,
        dataSource
      }),
    };
  });
  const length = columns.length -1;
  if(!props.editMode && columns[length]?.title === 'Delete'){
    columns.splice(length, 1);
  }
  return (
    <div className="incomeSourcesTable">
      <Table
        scroll={{
          x: true,
        }}
        components={components}
        rowClassName={() => "editable-row"}
        bordered
        dataSource={filterLiabilitiesByOwnership(dataSource, 'ownership', props.currentView)}
        columns={columns}
        pagination={false}
      />
     {props.editMode ? <Button onClick={handleAdd} type="form1003AddRow" className="mt-3">
        <img
          src="/images/bluePlusInCircleMark.png"
          style={{ width: 15, height: 15 }}
          className="mr-2"
        />
        Add financial accounts
      </Button> : null}
    </div>
  );
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(IncomeSourcesTable);

const OtherAssets = (props) => {
  const [dataSource, setDataSource] = useState(
    props.assetsandliabilities.otherassets === null
      ? []
      : props.assetsandliabilities.otherassets.map((a, i) => ({
          key: a.key,
          assettype: a.assettype,
          value: a.value,
          attribution: a.attribution,
          ownership: a.ownership,
        }))
  );
  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
    sendData(newData)
  };
  const defaultColumns = [
    {
      title: "ASSET OR CREDIT TYPE",
      dataIndex: "assettype",
      type: "select",
      options: ASSET_TYPE.LIST,
      render: (value) => ASSET_TYPE?.MAP?.[value]
    },
    {
      title: "CASH/MARKET VALUE",
      dataIndex: "value",
      type: "inputdollar",
    },
    props.application.hascoborrower === "withcoborrower" && {
      title: "Ownership",
      dataIndex: "ownership",
      type: "select",
      options: getFilteredOwnershipOptions(props.currentView),
      render: (value) => OWNERSHIP_TYPE.MAP[value]
    },
    {
      title: "Delete",
      fixed: 'right',
      width: 80,
      dataIndex: "operation",
      type: "operation",
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record.key)}
          >
            <MinusCircleOutlined  style={{fontSize:16, color:"#325CEB", cursor:"pointer"}}/>
          </Popconfirm>
        ) : null,
    },
  ];
  const handleAdd = () => {
    const newData = {
      key: Math.random().toString(),
      assettype: "",
      value: "",
      description: "",
      attribution: "",
    };
    setDataSource([...dataSource, newData]);
  };
  const sendData = (newData) => {
    let tosend = newData.map((d) => {
      return {
        key: d.key,
        assettype: d.assettype,
        value: normalizeDollarValue(d.value),
        attribution: null,
        description: "",
        ownership: d.ownership
      };
    });
    props.bulkAddBorrowerOtherAssets(tosend, "borrower");
  }
  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
    sendData(newData)
  };
  const components = props.editMode ? {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  } : undefined ;
  const columns = defaultColumns.filter(Boolean).map((col) => {
    return {
      ...col,
      onCell: (record) => ({
        record,
        type: col.type,
        options: col.options,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        editMode: props.editMode
      }),
    };
  });
  const length = columns.length -1;
  if(!props.editMode && columns[length]?.title === 'Delete'){
    columns.splice(length, 1);
  }
  return (
    <div className="incomeSourcesTable">
      <Table
        scroll={{
          x: true,
        }}
        components={components}
        rowClassName={() => "editable-row"}
        bordered
        dataSource={filterLiabilitiesByOwnership(dataSource, 'ownership', props.currentView)}
        columns={columns}
        pagination={false}
      />
     {props.editMode ? <Button onClick={handleAdd} type="form1003AddRow" className="mt-3">
        <img
          src="/images/bluePlusInCircleMark.png"
          style={{ width: 15, height: 15 }}
          className="mr-2"
        />
        Add assets or credits
      </Button> : null}
    </div>
  );
};
export const OtherAssetsTable = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(OtherAssets);

const Liabilities = (props) => {
  const [dataSource, setDataSource] = useState(
    props.assetsandliabilities.loans === null
      ? []
      : props.assetsandliabilities.loans
  )
  const [count, setCount] = useState(
    props.assetsandliabilities.loans === null
      ? 0
      : props.assetsandliabilities.loans.length
  )
  const [hasAddedEmptyRow, setHasAddedEmptyRow] = useState(false);
  useEffect(() => {
    setDataSource(props.assetsandliabilities.loans === null ? [] : props.assetsandliabilities.loans)
    setCount(props.assetsandliabilities.loans === null ? 0 : props.assetsandliabilities.loans.length)
  }, [props.assetsandliabilities.loans?.length])
  const sendData = (newData) => {
    props.bulkAddBorrowerLoans(newData, "borrower");
  }
  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
    sendData(newData)
  };
  const getProperties = (application, currentView) => {
    const isPurchase = application.property.purpose === "purchase"
    let properties = []
    const getSectionDescription = (index) => {
      if (index === 0) return "Section 3a. Property you own"
      if (index === 1) return "Section 3b. Additional Property"
      if (index === 2) return "Section 3c. Additional Property"
      return `Extra Property ${index - 2}`
  }
    if (!isPurchase) {
        // 只有当 loans 存在且不为空时才添加
        if (application.property.loans && application.property.loans.length > 0) {
            properties.push({
                address: application.property.address,
                loans: application.property.loans,
                sectionDescription: getSectionDescription(0),
            })
        }

        application[currentView].ownedproperties.forEach((property, index) => {
            // 只有当 loans 存在且不为空时才添加
            if (property.loans && property.loans.length > 0) {
                properties.push({
                    address: property.address,
                    loans: property.loans,
                    sectionDescription: getSectionDescription(index + 1),
                })
            }
        })
    } else {
        application[currentView].ownedproperties.forEach((property, index) => {
            // 只有当 loans 存在且不为空时才添加
            if (property.loans && property.loans.length > 0) {
                properties.push({
                    address: property.address,
                    loans: property.loans,
                    sectionDescription: getSectionDescription(index),
                })
            }
        })
    }

    return properties
  }
  const properties = getProperties(props.application, props.who)
  const defaultColumns = [
    {
      title: (
        <Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>
          Category
        </Paragraph>
      ),
      width: 120,
      dataIndex: "creditliabilityaccounttype",
      type: "select",
      options: LIABILITIES_ACCOUNT_TYPE.LIST,
      sorter: (a, b) => {
        const typeA = LIABILITIES_ACCOUNT_TYPE.MAP?.[a.creditliabilityaccounttype] || '';
        const typeB = LIABILITIES_ACCOUNT_TYPE.MAP?.[b.creditliabilityaccounttype] || '';
        return typeA.localeCompare(typeB);
      },
      render: (value) => LIABILITIES_ACCOUNT_TYPE.MAP?.[value]
    },
    {
      title: (
        <Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ marginBottom: 0 }}>
          Company Name
        </Paragraph>
      ),
      dataIndex: "name",
      type: "input",
    },
    {
      title: (
        <Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ marginBottom: 0 }}>
          Account Number
        </Paragraph>
      ),
      dataIndex: "accountnumber",
      type: "input",
    },
    {
      title: (
        <Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ marginBottom: 0 }}>
          Unpaid Balance
        </Paragraph>
      ),
      dataIndex: "remainingbalance",
      type: "inputdollar",
      sorter: (a, b) => Number(a.remainingbalance) - Number(b.remainingbalance),
    },
    {
      title: (
        <Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ marginBottom: 0 }}>
          Mo. Payment
        </Paragraph>
      ),
      dataIndex: "monthlypayment",
      type: "inputdollarmonth",
      sorter: (a, b) => Number(a.monthlypayment) - Number(b.monthlypayment),
    }, 
    props.application.hascoborrower === "withcoborrower" && {
      title: (
        <Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>
          Ownership
        </Paragraph>
      ),
      dataIndex: "creditliabilityShownOwnershipType",
      type: "select",
      options: getFilteredOwnershipOptions(props.who),
      sorter: (a, b) => {
        const order = { Borrower: 1, CoBorrower: 2, Joint: 3 };
        return (order[a.creditliabilityShownOwnershipType] || 99) - (order[b.creditliabilityShownOwnershipType] || 99);
      },
      render: (value) => OWNERSHIP_TYPE.MAP[value]
    },
    {
      title: (
        <Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ marginBottom: 0 }}>
          Paid off at/before closing
        </Paragraph>
      ),
      dataIndex: "paidoffatclosing",
      type: "select",
      options: PREPAID.LIST,
      sorter: (a, b) => {
        // yes > no
        const order = { yes: 1, no: 2 };
        return (order[(a.paidoffatclosing || '').toLowerCase()] || 99) - (order[(b.paidoffatclosing || '').toLowerCase()] || 99);
      },
      render: (value) => PREPAID.MAP[value]
    },
    {
      title: "Delete",
      fixed: 'right',
      width: 76,
      dataIndex: "operation",
      type: "operation",
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <div className="d-flex justify-content-center">
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => handleDelete(record.key)}
            >
              <MinusCircleOutlined  style={{fontSize:16, color:"#325CEB", cursor:"pointer"}}/>
            </Popconfirm>
          </div>
        ) : null,
    },
  ];
  const handleAdd = () => {
    let newData = new st.loan().toJson();
    newData = JSON.parse(newData)
    newData.creditliabilityShownOwnershipType = props.who === 'borrower' ? 'Borrower' : 'CoBorrower'
    newData.key = Math.random().toString();
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
    setHasAddedEmptyRow(true);
  };
  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
    sendData(newData)
  };
  const handleLinkClick = () => {
    if (props.onLinkClick) {
      props.onLinkClick()
    }
  }
  const components = props.editMode ? {
    body: {
      row: EditableRow,
      cell: LiabilitiesEditableCell,
    },
  } : undefined;
  const columns = defaultColumns.filter(Boolean).map((col) => {
    return {
      ...col,
      onCell: (record) => ({
        record,
        type: col.type,
        options: col.options,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        editMode: props.editMode,
        properties,
        dataSource,
        onLinkClick: handleLinkClick,
        application: props.application,
        hasAddedEmptyRow
      }),
    };
  });
  const length = columns.length -1;
  if(!props.editMode && columns[length]?.title === 'Delete'){
    columns.splice(length, 1);
  }
  return (
    <div style={{width: '100%'}}>
      <Table
        scroll={{
          x: true,
        }}
        className="liabilitiesTable"
        components={components}
        rowClassName={() => "editable-row"}
        bordered={false}
        dataSource={filterLiabilitiesByOwnership(dataSource, 'creditliabilityShownOwnershipType', props.who)}
        columns={columns}
        pagination={false}
      />
      {props.editMode ? <Button onClick={handleAdd} type="form1003AddRow" className="mt-3">
        <img
          src="/images/bluePlusInCircleMark.png"
          style={{ width: 15, height: 15 }}
          className="mr-2"
        />
        Add liability
      </Button> : null}
    </div>
  );
};
export const LiabilitiesTable = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(Liabilities);

const OtherLiabilities = (props) => {
  const [dataSource, setDataSource] = useState(
    props.who === "borrower"?
    (props.application.borrower.finances.alimony === null
      ? []
      : props.application.borrower.finances.alimony)
    :
    (props.application.coborrower.finances.alimony === null
      ? []
      : props.application.coborrower.finances.alimony)
  );

  useEffect(() => {
    setDataSource(
      props.who === "borrower"
        ? props.application.borrower.finances.alimony === null
          ? []
          : props.application.borrower.finances.alimony
        : props.application.coborrower.finances.alimony === null
        ? []
        : props.application.coborrower.finances.alimony
    );
  }, [props.who]);

  const sendData = (newData) => {
    props.bulkAddAlimonys(newData.map((item) => ({
      ...item,
      amount: normalizeDollarValue(item.amount),
    })), props.who);
  }
  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
    sendData(newData)
  };
  const defaultColumns = [
    {
      title: "TYPE",
      dataIndex: "alimonyorsupport",
      type: "select",
      options: ALIMONY_SUPPORT.LIST,
      render: (value) => ALIMONY_SUPPORT.MAP[value]
    },
    {
      title: "MONTHLY PAYMENT",
      dataIndex: "amount",
      type: "inputdollar",
    },
    {
      title: "Delete",
      fixed: 'right',
      width: 80,
      dataIndex: "operation",
      type: "operation",
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record.key)}
          >
            <MinusCircleOutlined  style={{fontSize:16, color:"#325CEB", cursor:"pointer"}}/>
          </Popconfirm>
        ) : null,
    },
  ];
  const handleAdd = () => {
    let newData = new st.alimony().toJson();
    newData = JSON.parse(newData)
    newData.key = Math.random().toString();
    setDataSource([...dataSource, newData]);
  };
  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
    sendData(newData)
  };
  const components = props.editMode ? {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  } : undefined;
  const columns = defaultColumns.filter(Boolean).map((col) => {
    return {
      ...col,
      onCell: (record) => ({
        record,
        type: col.type,
        options: col.options,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        editMode: props.editMode
      }),
    };
  });
  const length = columns.length -1;
  if(!props.editMode && columns[length]?.title === 'Delete'){
    columns.splice(length, 1);
  }
  return (
    <div className="incomeSourcesTable">
      <Table
        scroll={{
          x: true,
        }}
        components={components}
        rowClassName={() => "editable-row"}
        bordered
        dataSource={dataSource}
        columns={columns}
        pagination={false}
      />
      {props.editMode && dataSource.length < 3 && (
        <Button onClick={handleAdd} type="form1003AddRow" className="mt-3">
          <img
            src="/images/bluePlusInCircleMark.png"
            style={{ width: 15, height: 15 }}
            className="mr-2"
          />
          Add other liability
        </Button>
      )}
    </div>
  );
};
export const OtherLiabilitiesTable = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(OtherLiabilities);

const Property = (props) => {
  const [dataSource, setDataSource] = useState(
    props.assetsandliabilities.loans === null
      ? []
      : props.assetsandliabilities.loans
  );

  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
    sendData(newData)
  };
  const defaultColumns = [
    {
      title: "ASSET TYPE",
      dataIndex: "creditliabilityaccounttype",
      type: "select",
      options: CLAT.LIST,
      render: (value) => CLAT.MAP?.[value]
    },
    {
      title: "UNPAID BALANCE",
      dataIndex: "remainingbalance",
      type: "inputdollar",
    },
    {
      title: "Delete",
      fixed: 'right',
      width: 80,
      dataIndex: "operation",
      type: "operation",
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record.key)}
          >
            <MinusCircleOutlined  style={{fontSize:16, color:"#325CEB", cursor:"pointer"}}/>
          </Popconfirm>
        ) : null,
    },
  ];
  const handleAdd = () => {
    let newData = new st.loan();
    newData.key = Math.random().toString();
    setDataSource([...dataSource, newData]);
  };
  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
    sendData(newData)
  };
  const components = props.editMode ? {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  } : undefined ;
  const columns = defaultColumns.filter(Boolean).map((col) => {
    return {
      ...col,
      onCell: (record) => ({
        record,
        type: col.type,
        options: col.options,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        editMode: props.editMode
      }),
    };
  });
  const length = columns.length -1;
  if(!props.editMode && columns[length]?.title === 'Delete'){
    columns.splice(length, 1);
  }
  const sendData = (newData) => {
    props.bulkAddBorrowerLoans(newData, "borrower");
  }
  return (
    <div className="incomeSourcesTable">
      <Table
        scroll={{
          x: true,
        }}
        components={components}
        rowClassName={() => "editable-row"}
        bordered
        dataSource={dataSource}
        columns={columns}
        pagination={false}
      />
      <Button onClick={handleAdd} type="form1003AddRow" className="mt-3">
        <img
          src="/images/bluePlusInCircleMark.png"
          style={{ width: 15, height: 15 }}
          className="mr-2"
        />
        Add liability
      </Button>
    </div>
  );
};
export const PropertyTable = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(Property);

const PropertyMortgages = (props) => {
  const otherLoans = props.assetsandliabilities.newloans===null ? [] : props.assetsandliabilities.newloans
  const [dataSource, setDataSource] = useState(
    props.assetsandliabilities.newloans === null
      ? []
      : props.assetsandliabilities.newloans
  );

  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
    sendData(newData)
  };
  const defaultColumns = [
    {
      title: "CREDITOR NAME",
      dataIndex: "creditor",
      type: "input",
    },
    {
      title: "LIEN TYPE",
      dataIndex: "lientype",
      type: "select",
      options: LIEN_TYPE.LIST,
      render: (value) => LIEN_TYPE.MAP[value]
    },
    {
      title: "MONTHLY AMOUNT",
      dataIndex: "monthlyamount",
      type: "inputdollarmonth",
    },
    {
      title: "LOAN AMOUNT",
      dataIndex: "loanamount",
      type: "inputdollar",
    },
    {
      title: "CREDIT LIMIT",
      dataIndex: "creditlimit",
      type: "inputdollar",
    },
    {
      title: "Delete",
      fixed: 'right',
      width: 80,
      dataIndex: "operation",
      type: "operation",
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record.key)}
          >
            <MinusCircleOutlined  style={{fontSize:16, color:"#325CEB", cursor:"pointer"}}/>
          </Popconfirm>
        ) : null,
    },
  ];
  const handleAdd = () => {
    let newData = new st.newmortgage().toJson();
    newData = JSON.parse(newData)
    newData.key = Math.random().toString();
    newData.lientype = "firstlien"
    setDataSource([...dataSource, newData]);
  };
  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
    sendData(newData)
  };
  const components = props.editMode ? {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  } : undefined;
  const columns = defaultColumns.filter(Boolean).map((col) => {
    return {
      ...col,
      onCell: (record) => ({
        record,
        type: col.type,
        options: col.options,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        editMode: props.editMode
      }),
    };
  });
  const length = columns.length -1;
  if(!props.editMode && columns[length]?.title === 'Delete'){
    columns.splice(length, 1);
  }
  const sendData = (newData) => {
    props.bulkAddNewMortgageLoan(newData.map((item) => ({
      ...item,
      monthlyamount: normalizeDollarValue(item.monthlyamount),
      loanamount: normalizeDollarValue(item.loanamount),
      creditlimit: normalizeDollarValue(item.creditlimit),
    })));
  }
  return (
    <div className="incomeSourcesTable">
      <Table
        scroll={{
          x: true,
        }}
        components={components}
        rowClassName={() => "editable-row"}
        bordered
        dataSource={dataSource}
        columns={columns}
        pagination={false}
      />
     {props.editMode ? <Button onClick={handleAdd} type="form1003AddRow" className="mt-3">
        <img
          src="/images/bluePlusInCircleMark.png"
          style={{ width: 15, height: 15 }}
          className="mr-2"
        />
        Add mortgage loan
      </Button> : null}
    </div>
  );
};
export const PropertyMortgagesTable = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(PropertyMortgages);


const OwnedPropertyLoans = (props) => {
  const [dataSource, setDataSource] = useState(props.isSubjectProperty ? props.application.property.loans : props.application[props.currentView].ownedproperties[props.i].loans);
  const [hasAddedEmptyRow, setHasAddedEmptyRow] = useState(false);
  useEffect(() => {
    setDataSource(props.isSubjectProperty 
      ? props.application.property.loans 
      : props.application[props.currentView].ownedproperties[props.i].loans
    );
  }, [
    props.currentView,
    props.isSubjectProperty,
    props.application.property.loans?.length,
    props.application[props.currentView]?.ownedproperties[props.i]?.loans?.length,
    props.i
  ]);
  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
    sendData(newData)
  };
  const defaultColumns = [
    {
      title: (
        <Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ marginBottom: 0 }}>
          Type
        </Paragraph>
      ),
      width: "16%",
      dataIndex: "creditloantype",
      type: "select",
      options: CREDIT_LOAN_TYPE.LIST,
      render: (value) => CREDIT_LOAN_TYPE.MAP[value]
    },
    {
      title: (
        <Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ marginBottom: 0 }}>
          Creditor name
        </Paragraph>
      ),
      dataIndex: "name",
      type: "input",
    },
    {
      title: (
        <Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ marginBottom: 0 }}>
          Account Number
        </Paragraph>
      ),
      dataIndex: "accountnumber",
      type: "input",
    },
    {
      title: (
        <Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ marginBottom: 0 }}>
          Mo. Payment
        </Paragraph>
      ),
      dataIndex: "monthlypayment",
      type: "inputdollarmonth",
    },
    {
      title: (
        <Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ marginBottom: 0 }}>
          Unpaid Balance
        </Paragraph>
      ),
      dataIndex: "remainingbalance",
      type: "inputdollar",
    },
    {
      title: (
        <Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ marginBottom: 0 }}>
          Paid off at/before closing
        </Paragraph>
      ),
      dataIndex: "paidoffatclosing",
      type: "select",
      options: PREPAID.LIST,
      render: (value) => PREPAID.MAP[value]
    },
    {
      title: (
        <Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ marginBottom: 0 }}>
          Credit limit (if applicable)
        </Paragraph>
      ),
      dataIndex: "creditlimit",
      type: "inputdollar",
    },
    {
      title: "Delete",
      fixed: 'right',
      width: 80,
      dataIndex: "operation",
      type: "operation",
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <div className="d-flex justify-content-center">
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => handleDelete(record.key)}
            >
              <MinusCircleOutlined  style={{fontSize:16, color:"#325CEB", cursor:"pointer"}}/>
            </Popconfirm>
          </div>
        ) : null,
    },
  ];
  const handleAdd = () => {
    let newData = new st.loan().toJson();
    newData = JSON.parse(newData)
    newData.creditloantype = "ConventionalRealEstateMortgage"
    newData.key = Math.random().toString();
    setDataSource([...dataSource, newData]);
    setHasAddedEmptyRow(true);
  };
  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
    sendData(newData)
  };
  const components = props.editMode ? {
    body: {
      row: EditableRow,
      cell: OwnedPropertyLoansEditableCell,
    },
  } : undefined;
  const columns = defaultColumns.filter(Boolean).map((col) => {
    return {
      ...col,
      onCell: (record) => ({
        record,
        type: col.type,
        options: col.options,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        editMode: props.editMode,
        hasAddedEmptyRow,
        dataSource
      }),
    };
  });
  const length = columns.length -1;
  if(!props.editMode && columns[length]?.title === 'Delete'){
    columns.splice(length, 1);
  }
  const sendData = (newData) => {
    if (props.isSubjectProperty) {
      props.changeMainProperty(newData,"loans")
    } else {
      if (props.currentView === "borrower"){
        props.changeBorrowerOwnedProperty(newData,props.i,"loans")
      }
      if (props.currentView === "coborrower"){
        props.changeCoborrowerOwnedProperty(newData,props.i,"loans")
      }
    }
  }
  return (
    <div style={{width: '100%'}}>
      {dataSource.length > 0 && (
        <Table
          scroll={{
            x: true,
          }}
          className="ownedPropertyLoansTable"
          components={components}
          rowClassName={() => "editable-row"}
          bordered={false}
          dataSource={dataSource}
          columns={columns}
          pagination={false}
        />
      )}
      {props.editMode && dataSource.length < 2 && (
        <Button onClick={handleAdd} type="form1003AddRow" >
          <img
            src="/images/bluePlusInCircleMark.png"
            style={{ width: 15, height: 15 }}
            className="mr-2"
          />
          Add mortgage loans on this property
        </Button>
      )}
    </div>
  );
};
export const OwnedPropertyLoansTable = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(OwnedPropertyLoans);

const Gifts = (props) => {
  const [dataSource, setDataSource] = useState(
    props.assetsandliabilities.gifts === null
      ? []
      : props.assetsandliabilities.gifts.map((a, i) => {
        const description = a.sourcedescription || a.source
        return {
          assettype: a.assettype,
          deposited: a.deposited,
          sourcedescription: description,
          source: a.source,
          value: a.value,
          key: a.key,
          attribution: a.attribution,
          ownership: a.ownership
        }
      })
  );
  
  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
    sendData(newData)
  };

  const defaultColumns = [
    {
      title: "ASSET OR CREDIT TYPE",
      dataIndex: "assettype",
      type: "select",
      options: ASSET_CREDIT_TYPE.LIST,
      render: (value) => ASSET_CREDIT_TYPE.MAP[value]
    },
    {
      title: "DEPOSITED/NOT",
      dataIndex: "deposited",
      type: "select",
      options: DEPOSITED.LIST,
      render: (value) => DEPOSITED.MAP[value]
    },
    {
      title: "SOURCE",
      dataIndex: "sourcedescription",
      type: "select",
      options: SOURCE_DESCRIPTION.LIST,
      render: (value) => SOURCE_DESCRIPTION.MAP[value]
    },
    {
      title: "CASH/MARKET VALUE",
      dataIndex: "value",
      type: "inputdollar",
    },
    props.application.hascoborrower === "withcoborrower" && {
      title: "Ownership",
      dataIndex: "ownership",
      type: "select",
      options: getFilteredOwnershipOptions(props.currentView),
      render: (value) => OWNERSHIP_TYPE.MAP[value]
    },
    {
      title: "Delete",
      fixed: 'right',
      width: 80,
      dataIndex: "operation",
      type: "operation",
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record.key)}
          >
            <MinusCircleOutlined  style={{fontSize:16, color:"#325CEB", cursor:"pointer"}}/>
          </Popconfirm>
        ) : null,
    },
  ];

  const handleAdd = () => {
    const newData = {
      assettype: "",
      deposited: true,
      sourcedescription: "",
      source: "",
      value: "",
      key: Math.random().toString(),
      attribution: null,
    };
    setDataSource([...dataSource, newData]);
  };

  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
    sendData(newData)
  };

  const components = props.editMode ? {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  } : undefined;

  const columns = defaultColumns.filter(Boolean).map((col) => {
    return {
      ...col,
      onCell: (record) => ({
        record,
        type: col.type,
        options: col.options,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        editMode: props.editMode
      }),
    };
  });
  
  const length = columns.length -1;
  if(!props.editMode && columns[length]?.title === 'Delete'){
    columns.splice(length, 1);
  }
  const sendData = (newData) => {
    props.bulkAddBorrowerGifts(newData, "borrower");
  }

  return (
    <div className="incomeSourcesTable">
      <Table
        scroll={{
          x: true,
        }}
        components={components}
        rowClassName={() => "editable-row"}
        bordered
        dataSource={filterLiabilitiesByOwnership(dataSource, 'ownership', props.currentView)}
        columns={columns}
        pagination={false}
      />
      {props.editMode ? <Button onClick={handleAdd} type="form1003AddRow" className="mt-3">
        <img
          src="/images/bluePlusInCircleMark.png"
          style={{ width: 15, height: 15 }}
          className="mr-2"
        />
        Add assets or credits
      </Button> : null}
    </div>
  );
};
export const GiftsTable = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(Gifts);
